export default __webpack_public_path__ + "static/media/tri-right.c08ae256.svg";